import React from "react";
import { L10nId, L10n } from "@fidget/common/i18n";
import { DashboardView } from "../../containers/dashboard/views/DashboardView";
import { NavButton } from "./navButton";
import styles from "./navButtonGroup.css";

interface Props extends React.PropsWithChildren<{}> {
  labelId: L10nId;
  currentView: DashboardView;
  groupViews: DashboardView[];
  linkTo: string;
}

export const NavButtonGroup = ({ children, labelId, currentView, groupViews, linkTo }: Props) => {
  const isActive = !!groupViews.find((v) => v === currentView);
  const render = () => {
    return (
      <>
        <NavButton isActive={isActive} linkTo={linkTo} isGroupStyle>
          <L10n id={labelId} />
        </NavButton>
        {isActive && <div className={styles.children}>{children}</div>}
      </>
    );
  };

  return render();
};
